import { Tooltip, useTheme } from '@mui/material';
import { IconType } from '../../../@types/icons';
import Icon from 'components/icons/Icon';
import { FunctionComponent, ReactNode } from 'react';

type StatusIconProps = {
  tooltip?: string;
  size?: string;
  color: string;
  icon: IconType;
};
const StatusIcon = ({ tooltip = '', size = '20px', color, icon }: StatusIconProps) => {
  const theme = useTheme();
  return (
    <IconWrapper size={size}>
      <Tooltip title={tooltip}>
        <Icon
          type={icon}
          id="statusIcon"
          sx={{
            color: color,
            fontSize: size
          }}
          fill={theme.palette.background.paper}
        />
      </Tooltip>
    </IconWrapper>
  );
};
export default StatusIcon;

interface IconWrapperProps {
  size: string;
  children: ReactNode;
}

const IconWrapper: FunctionComponent<IconWrapperProps> = ({ size, children }) => {
  return (
    <div
      style={{
        position: 'relative',
        width: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
        borderRadius: '50%'
      }}
    >
      {children}
    </div>
  );
};
